module.exports = __webpack_public_path__ + "img/tour-65.9892c589.png";